module.exports = __webpack_public_path__ + "img/seo-content-collapsible-infiniti.d7c5d10a.png";